export const errors = [
  {
    id: "ERR001",
    vendor: "Amadeus",
    module: "Flight",
    endpoint: "/flight/book",
    errorMessage: "429 Too Many Requests",
    detailsMessage:
      "Vendor API returned HTTP 429 (rate limit). This usually happens when burst traffic exceeds the vendor threshold. The request was rejected before booking confirmation.",
    functionName: "bookFlight",
    errorJson: {
      statusCode: 429,
      error: "Too Many Requests",
      message: "Rate limit exceeded",
      vendor: "Amadeus",
      endpoint: "/flight/book",
      retryAfterSeconds: 30,
    },
    severity: "High",
    status: "Open",
    createdAt: "2026-03-13 10:32",
  },
  {
    id: "ERR002",
    vendor: "Hotelbeds",
    module: "Hotel",
    endpoint: "/hotel/availability",
    errorMessage: "Timeout Error",
    detailsMessage:
      "Availability request timed out while waiting for vendor response. This can be caused by vendor latency spikes, network issues, or aggressive timeout settings.",
    functionName: "getHotelAvailability",
    errorJson: {
      statusCode: 504,
      error: "Gateway Timeout",
      message: "Upstream request timed out",
      vendor: "Hotelbeds",
      endpoint: "/hotel/availability",
      timeoutMs: 15000,
    },
    severity: "Medium",
    status: "Investigating",
    createdAt: "2026-03-13 09:15",
  },
  {
    id: "ERR003",
    vendor: "TBO",
    module: "Excursion",
    endpoint: "/excursion/search",
    errorMessage: "500 Internal Server Error",
    detailsMessage:
      "Vendor returned a 500 response for the excursion search query. This is likely an intermittent vendor issue or invalid request payload mapping.",
    functionName: "searchExcursions",
    errorJson: {
      statusCode: 500,
      error: "Internal Server Error",
      message: "Unexpected error from vendor",
      vendor: "TBO",
      endpoint: "/excursion/search",
      correlationId: "TBO-REQ-7H2K9",
    },
    severity: "High",
    status: "Open",
    createdAt: "2026-03-13 08:42",
  },
  {
    id: "ERR004",
    vendor: "Stripe",
    module: "Payment",
    endpoint: "/payments/charge",
    errorMessage: "Card declined",
    detailsMessage: "Payment was declined by the payment processor.",
    functionName: "createCharge",
    errorJson: { statusCode: 402, error: "Payment Required" },
    severity: "Low",
    status: "Resolved",
    createdAt: "2026-03-12 17:05",
  },
  {
    id: "ERR005",
    vendor: "Amadeus",
    module: "Flight",
    endpoint: "/flight/search",
    errorMessage: "No availability",
    detailsMessage: "No flights found for the specified criteria.",
    functionName: "searchFlights",
    errorJson: { statusCode: 404, error: "Not Found" },
    severity: "Low",
    status: "Resolved",
    createdAt: "2026-03-13 11:20",
  },
  {
    id: "ERR006",
    vendor: "Hotelbeds",
    module: "Hotel",
    endpoint: "/hotel/booking",
    errorMessage: "Invalid guest details",
    detailsMessage: "The guest information provided was rejected by the vendor.",
    functionName: "bookHotel",
    errorJson: { statusCode: 400, error: "Bad Request" },
    severity: "Medium",
    status: "Open",
    createdAt: "2026-03-13 12:45",
  },
  {
    id: "ERR007",
    vendor: "Viator",
    module: "Excursion",
    endpoint: "/excursion/availability",
    errorMessage: "Authentication failed",
    detailsMessage: "The API key provided for Viator has expired or is invalid.",
    functionName: "checkExcursionAvailability",
    errorJson: { statusCode: 401, error: "Unauthorized" },
    severity: "High",
    status: "Open",
    createdAt: "2026-03-13 14:10",
  },
  {
    id: "ERR008",
    vendor: "TBO",
    module: "Hotel",
    endpoint: "/hotel/cancel",
    errorMessage: "Cancellation not allowed",
    detailsMessage: "Current booking status does not allow cancellation.",
    functionName: "cancelBooking",
    errorJson: { statusCode: 403, error: "Forbidden" },
    severity: "Medium",
    status: "Investigating",
    createdAt: "2026-03-13 15:30",
  },
  {
    id: "ERR009",
    vendor: "Amadeus",
    module: "Flight",
    endpoint: "/flight/upsell",
    errorMessage: "System Maintenance",
    detailsMessage: "Vendor system is currently down for scheduled maintenance.",
    functionName: "getUpsell",
    errorJson: { statusCode: 503, error: "Service Unavailable" },
    severity: "High",
    status: "Open",
    createdAt: "2026-03-13 16:45",
  },
  {
    id: "ERR010",
    vendor: "Hotelbeds",
    module: "Hotel",
    endpoint: "/hotel/info",
    errorMessage: "Resource Not Found",
    detailsMessage: "The requested hotel ID does not exist in the vendor database.",
    functionName: "getHotelInfo",
    errorJson: { statusCode: 404, error: "Not Found" },
    severity: "Low",
    status: "Resolved",
    createdAt: "2026-03-13 17:15",
  }
];

